import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function TaskDeadline({ deadline }: { deadline?: string }) {
  const { t } = useTranslation();

  return (
    <div className="relative !mb-0 !mt-5 h-1 w-full bg-[#FA6238] lg:!mt-6">
      <p className="absolute right-[25%] top-[-12px] !mb-0 w-[50%] bg-white px-[12px] text-center font-bold text-[#FA6238] lg:right-[40%] lg:w-[20%]">
        {deadline ? moment(deadline).format('DD.MM.YYYY') : t('lessonGoal')}
      </p>
    </div>
  );
}
